import { useScrollIndicators } from "../../../../hooks/useScrollIndicators";
import { withTranslation } from "../../../../translation";
import styles from "./SelectedFacets.css";
import PropTypes from "prop-types";
import { useRef, useMemo } from "react";
import { useSelectedFacets } from "../../../../../state/hooks/useSelectedFacets";

const EMPTY_FACET_VALUES = [];

export const SelectedFacets = ({ formatTranslation }) => {
  const { displayedFacetValues, changeMultiFacet, clearAlwaysApply } =
    useSelectedFacets();

  const containerRef = useRef(null);
  const { canScrollLeft, canScrollRight } = useScrollIndicators(containerRef);
  const selectedFacetValues = displayedFacetValues || EMPTY_FACET_VALUES;
  const reverseSelectedFacetValues = useMemo(
    () => [...selectedFacetValues].reverse(),
    [selectedFacetValues],
  );

  const onClick = (facetValue) => {
    if (facetValue.facetId === "currentprice") {
      clearAlwaysApply("currentprice");
    } else {
      changeMultiFacet([
        {
          facetId: facetValue.facetId,
          valueId: facetValue.id,
          isSelected: false,
        },
      ]);
    }
  };

  const isScrollable = canScrollLeft || canScrollRight;
  const getMaskImage = (canScrollLeft, canScrollRight) => {
    const startColor = canScrollLeft ? "transparent" : "black";
    const endColor = canScrollRight ? "transparent" : "black";

    return `linear-gradient(to right, 
    ${startColor} 0%, 
    black 10%, 
    black 90%, 
    ${endColor} 100%)`;
  };

  if (selectedFacetValues.length === 0) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={styles.container}
      style={{
        maskImage: getMaskImage(canScrollLeft, canScrollRight),
        WebkitMaskImage: getMaskImage(canScrollLeft, canScrollRight),
        ...(isScrollable ? { marginTop: "4px" } : {}),
      }}
    >
      {reverseSelectedFacetValues.map((facetValue) => (
        <div key={facetValue.id} className={styles.facet}>
          <span className={styles.name}>{facetValue.name}</span>
          <button
            className={styles.close}
            type="button"
            onClick={() => onClick(facetValue)}
            aria-label={formatTranslation("accessibility_label_close")}
          />
        </div>
      ))}
    </div>
  );
};

SelectedFacets.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(SelectedFacets);
